export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public code: string | null = null,
    public body: unknown = null,
  ) {
    super(message);
  }
}

async function request(path: string, init?: RequestInit): Promise<Response> {
  return fetch(`/api${path}`, {
    credentials: "include",
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
    ...init,
  });
}

async function throwApiError(res: Response): Promise<never> {
  let msg = res.statusText;
  let code: string | null = null;
  let body: unknown = null;
  try {
    const parsed = (await res.json()) as Record<string, unknown> | null;
    body = parsed;
    if (parsed && typeof parsed.error === "string") msg = parsed.error;
    if (parsed && typeof parsed.code === "string") code = parsed.code;
  } catch {}
  throw new ApiError(res.status, msg, code, body);
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await request(path, init);
  if (!res.ok) await throwApiError(res);
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export interface ApiResponse<T> {
  status: number;
  data: T | null;
  headers: Headers;
}

export async function apiWithMeta<T>(
  path: string,
  init?: RequestInit,
): Promise<ApiResponse<T>> {
  const res = await request(path, init);
  if (res.status === 304 || res.status === 204) {
    return { status: res.status, data: null, headers: res.headers };
  }
  if (!res.ok) await throwApiError(res);
  const data = (await res.json()) as T;
  return { status: res.status, data, headers: res.headers };
}
